/** One answer to "should this motion run?" for JS-driven animation: the OS reduce-motion setting or the Preferences toggle. */

export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/** The Preferences toggle marks <html> with this class (usePreferenceEffects); the OS setting only reaches CSS and matchMedia. */
export const REDUCE_MOTION_CLASS = 'qs-reduce-motion';

/** Read at the moment the motion starts, so a setting changed mid-session applies to the next animation. */
export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined') return false;
  if (document.documentElement.classList.contains(REDUCE_MOTION_CLASS)) return true;
  return window.matchMedia?.(REDUCED_MOTION_QUERY).matches ?? false;
}

/** `behavior` for scrollTo/scrollIntoView: CSS scroll-behavior does not reach an explicit `smooth` passed from script. */
export function smoothScrollBehavior(): ScrollBehavior {
  return prefersReducedMotion() ? 'auto' : 'smooth';
}
